/* Meioca — Drop 01 | JS do tema Shopify
 * Sem dependências. Lê o JSON publicado por snippets/meioca-data.liquid.
 *
 * Envio dos formulários, em ordem:
 *   1. Shopify — formulário de cliente (consentimento de marketing + tag) e
 *      formulário de contato (e-mail com todos os campos da reserva).
 *   2. Klaviyo — assinatura da lista + evento, apenas se ativado nas configurações.
 * O passo 1 é obrigatório; o passo 2 é best-effort e nunca bloqueia a confirmação.
 */
(function () {
  "use strict";

  /* ---------------- Dados ---------------- */

  var DATA = { models: [], kits: [], sizes: [], config: {} };
  try {
    var node = document.getElementById("meioca-data");
    if (node) DATA = JSON.parse(node.textContent);
  } catch (e) {
    console.error("[meioca] JSON de configuração inválido:", e);
  }

  var CFG = DATA.config || {};
  var KLAVIYO = CFG.klaviyo || {};
  var KLAVIYO_REVISION = "2024-10-15";
  var GUARDA = "meioca:reserva";
  var GUARDA_LEAD = "meioca:lead";

  var options = [];
  (DATA.models || []).forEach(function (m) {
    (m.colorways || []).forEach(function (c) {
      options.push({ value: m.nome + " · " + c.nome, image: c.image });
    });
  });
  function imageFor(value) {
    for (var i = 0; i < options.length; i++) if (options[i].value === value) return options[i].image;
    return null;
  }

  var FIELD =
    "h-13 w-full border border-input bg-background px-4 py-3.5 text-base text-foreground placeholder:text-muted-foreground focus:border-primary focus:outline-none";

  /* ---------------- Utilidades ---------------- */

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function qs(name) {
    return new URLSearchParams(window.location.search).get(name);
  }
  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v).trim()) && String(v).length <= 255;
  }

  /* ---------------- Shopify ---------------- */

  // A loja tem proteção anti-bot ligada. O token de CAPTCHA só é injetado pelo
  // Shopify no evento de submit de um <form> renderizado pelo Liquid — um POST
  // montado à mão volta 400 ("Missing CAPTCHA token"). Por isso preenchemos o
  // formulário oculto e clicamos no botão dele, deixando o Shopify completar.
  function preencherFormulario(form, valores) {
    Object.keys(valores || {}).forEach(function (nome) {
      var campo = form.querySelector('[name="contact[' + nome + ']"]');
      if (campo) campo.value = valores[nome] == null ? "" : valores[nome];
    });
  }

  /* ---------------- Pixels de conversão ---------------- */

  // Converte "R$ 149,90" em 149.9 para o valor do evento.
  function valorNumerico(preco) {
    var n = String(preco || "").replace(/[^\d,.-]/g, "").replace(/\./g, "").replace(",", ".");
    var v = parseFloat(n);
    return isNaN(v) ? undefined : v;
  }

  // Dispara o mesmo evento nos três pixels, quando presentes.
  // A pré-venda não tem checkout, então a reserva é o evento de conversão.
  function rastrear(evento, dados) {
    dados = dados || {};
    try {
      if (typeof window.fbq === "function") {
        var meta = { content_name: dados.nome, content_category: "Drop 01" };
        if (dados.valor !== undefined) { meta.value = dados.valor; meta.currency = "BRL"; }
        window.fbq("track", evento === "reserva" ? "CompleteRegistration" : "Lead", meta);
        window.fbq("trackCustom", evento === "reserva" ? "ReservaPreVenda" : "ListaDoDrop", meta);
      }
      if (typeof window.gtag === "function") {
        window.gtag("event", evento === "reserva" ? "reserva_pre_venda" : "generate_lead", {
          currency: "BRL",
          value: dados.valor,
          item_name: dados.nome
        });
      }
      if (window.ttq && typeof window.ttq.track === "function") {
        window.ttq.track(evento === "reserva" ? "CompleteRegistration" : "SubmitForm", {
          content_name: dados.nome,
          value: dados.valor,
          currency: "BRL"
        });
      }
    } catch (e) {
      console.warn("[meioca] pixel falhou:", e);
    }
  }

  /* ---------------- Klaviyo ---------------- */

  function klaviyoOn() {
    return !!(KLAVIYO.ativo && KLAVIYO.companyId);
  }

  // O Klaviyo exige telefone em E.164. "(11) 98888-7777" é recusado e derruba
  // a inscrição inteira, então normalizamos ou omitimos.
  function telefoneE164(bruto) {
    var d = String(bruto || "").replace(/\D/g, "");
    if (!d) return undefined;
    if (d.length === 10 || d.length === 11) return "+55" + d;
    if ((d.length === 12 || d.length === 13) && d.indexOf("55") === 0) return "+" + d;
    return undefined;
  }

  function klaviyoPost(path, payload) {
    if (!klaviyoOn()) return Promise.resolve();
    return fetch("https://a.klaviyo.com/client/" + path + "/?company_id=" + encodeURIComponent(KLAVIYO.companyId), {
      method: "POST",
      headers: { "Content-Type": "application/json", revision: KLAVIYO_REVISION },
      body: JSON.stringify(payload),
      // Mantém a requisição viva quando o formulário navega logo em seguida.
      keepalive: true
    }).then(function (r) {
      if (!r.ok) {
        // Falha aqui não impede a reserva, mas precisa ser visível no console.
        return r.text().then(function (t) {
          console.error("[meioca] Klaviyo recusou " + path + " (HTTP " + r.status + "): " + t);
        });
      }
    }).catch(function (e) {
      console.error("[meioca] Klaviyo indisponível:", e);
    });
  }

  function klaviyoInscrever(perfil, origem) {
    if (!klaviyoOn() || !KLAVIYO.listId) return Promise.resolve();
    return klaviyoPost("subscriptions", {
      data: {
        type: "subscription",
        attributes: {
          custom_source: origem || "Site Meioca",
          // O endpoint client NÃO aceita o objeto "subscriptions" dentro do perfil
          // (400: 'subscriptions' is not a valid field for the resource 'profile').
          // O consentimento vem do próprio ato de chamar /client/subscriptions/,
          // combinado com o opt-in configurado na lista.
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: perfil.email,
                first_name: perfil.first_name || undefined,
                phone_number: perfil.phone_number || undefined,
                properties: perfil.properties || undefined
              }
            }
          }
        },
        relationships: { list: { data: { type: "list", id: KLAVIYO.listId } } }
      }
    });
  }

  function klaviyoEvento(metrica, perfil, propriedades) {
    if (!klaviyoOn() || !metrica) return Promise.resolve();
    return klaviyoPost("events", {
      data: {
        type: "event",
        attributes: {
          properties: propriedades || {},
          metric: { data: { type: "metric", attributes: { name: metrica } } },
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: perfil.email,
                first_name: perfil.first_name || undefined,
                phone_number: perfil.phone_number || undefined
              }
            }
          }
        }
      }
    });
  }

  /* ---------------- Confirmação da reserva ---------------- */

  // Desenhada nos dois caminhos: logo após o envio e, principalmente, ao voltar
  // do POST do Shopify, a partir do resumo guardado no sessionStorage.
  function confirmacao(root, d) {
    var tags = (d.modelos || []).map(function (p) {
      return '<span class="eyebrow border border-border px-3 py-2 text-foreground">' + esc(p) + "</span>";
    }).join("");

    root.innerHTML =
      '<div class="surface-card rise p-8 md:p-12">' +
      '<span class="display text-6xl text-primary">✓</span>' +
      '<h2 class="display mt-6 text-[clamp(2rem,4vw,3rem)]">Reserva confirmada</h2>' +
      '<p class="mt-4 max-w-xl leading-relaxed text-muted-foreground">Valeu, ' +
      esc(String(d.nome || "").split(" ")[0]) +
      '. Sua pré-venda do <strong class="text-foreground">' + esc(d.kitTitulo) +
      '</strong> está registrada. Assim que o Drop 01 abrir, mandamos o link de pagamento prioritário para <strong class="text-foreground">' +
      esc(d.email) + "</strong>.</p>" +
      '<dl class="mt-10 grid gap-px border border-border bg-border sm:grid-cols-2">' +
      '<div class="bg-card p-6"><dt class="eyebrow text-muted-foreground">Kit</dt><dd class="display mt-2 text-2xl">' +
      esc(d.kitTitulo + " · " + d.kitPreco) + "</dd></div>" +
      '<div class="bg-card p-6"><dt class="eyebrow text-muted-foreground">Numeração</dt><dd class="display mt-2 text-2xl">' +
      esc(d.numeracao || "—") + "</dd></div>" +
      '<div class="bg-card p-6 sm:col-span-2"><dt class="eyebrow text-muted-foreground">Modelos escolhidos</dt><dd class="mt-3 flex flex-wrap gap-2">' +
      tags + "</dd></div></dl>" +
      '<div class="mt-10 flex flex-wrap gap-3">' +
      '<a href="' + esc(CFG.urlHome || "/") + '" class="eyebrow inline-flex h-12 items-center border border-border px-6 transition-colors hover:bg-surface-2">Voltar à home</a>' +
      '<a href="' + esc(CFG.urlModelo06 || "/pages/modelo-06") + '" class="eyebrow inline-flex h-12 items-center bg-primary px-6 text-primary-foreground transition-transform hover:-translate-y-0.5">Sugerir o modelo 06</a>' +
      "</div></div>";

    root.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  /* ---------------- Pré-venda ---------------- */

  function mountPreOrder(root) {
    var kits = DATA.kits || [];
    var sizes = DATA.sizes || [];
    if (!kits.length) {
      root.innerHTML = '<p class="mc-flash mc-flash--erro">Nenhum kit configurado. Preencha a aba Kits nas configurações do tema.</p>';
      return;
    }

    var maiorKit = kits.reduce(function (m, k) { return Math.max(m, k.pairs || 0); }, 4);

    var padrao = parseInt(qs("kit") || root.getAttribute("data-initial-kit") || CFG.kitPadrao || 3, 10);
    var existe = kits.some(function (k) { return k.pairs === padrao; });

    var state = {
      pairs: existe ? padrao : kits[0].pairs,
      // Dimensionado pelo maior kit configurado, nao por um numero fixo:
      // assim um kit de 5, 6 ou 8 pares funciona sem mexer no codigo.
      picks: new Array(maiorKit).fill(""),
      size: "",
      consent: false,
      enviando: false,
      errors: {}
    };

    function kitOf() {
      for (var i = 0; i < kits.length; i++) if (kits[i].pairs === state.pairs) return kits[i];
      return kits[0];
    }

    function selectMarkup(index) {
      var html = '<option value="">Selecione o modelo</option>';
      (DATA.models || []).forEach(function (m) {
        html += '<optgroup label="' + esc(m.numero + " · " + m.nome) + '">';
        (m.colorways || []).forEach(function (c) {
          var v = m.nome + " · " + c.nome;
          html += '<option value="' + esc(v) + '"' + (state.picks[index] === v ? " selected" : "") + ">" + esc(c.nome) + "</option>";
        });
        html += "</optgroup>";
      });
      return html;
    }

    function thumb(value, size) {
      var img = value ? imageFor(value) : null;
      if (img) {
        return '<img src="' + esc(img) + '" alt="' + esc(value) + '" class="size-' + size + ' border border-border object-cover" loading="lazy" />';
      }
      return '<span class="size-' + size + ' border border-dashed border-border"></span>';
    }

    function validate(buyer) {
      var e = {};
      var nome = buyer.name.trim();
      if (nome.length < 2 || nome.length > 100) e.name = "Informe seu nome (2 a 100 caracteres).";
      if (!validEmail(buyer.email)) e.email = "Informe um e-mail válido.";
      if (buyer.whatsapp.trim() && buyer.whatsapp.replace(/\D/g, "").length < 10) e.whatsapp = "WhatsApp incompleto.";
      if (buyer.city.trim().length > 80) e.city = "Máximo de 80 caracteres.";
      if (buyer.note.length > 500) e.note = "Máximo de 500 caracteres.";
      if (!state.size && sizes.length) e.size = "Escolha sua numeração.";
      for (var i = 0; i < state.pairs; i++) if (!state.picks[i]) e.picks = "Escolha um modelo para cada par do kit.";
      if (!state.consent) e.consent = "É preciso aceitar para concluir a reserva.";
      return e;
    }

    function err(key) {
      return state.errors[key] ? '<p class="mt-2 text-sm text-destructive">' + esc(state.errors[key]) + "</p>" : "";
    }

    function modelosEscolhidos() {
      return state.picks.slice(0, state.pairs);
    }

    function success(buyer) {
      var kit = kitOf();
      confirmacao(root, {
        nome: buyer.name,
        email: buyer.email,
        kitTitulo: kit.title,
        kitPreco: kit.price,
        numeracao: state.size,
        modelos: modelosEscolhidos()
      });
    }

    function render(buyer) {
      buyer = buyer || {
        name: "",
        email: qs("email") || "",
        whatsapp: "",
        city: "",
        note: ""
      };
      var kit = kitOf();

      var kitButtons = kits.map(function (k) {
        var active = k.pairs === state.pairs;
        return '<button type="button" data-kit="' + k.pairs + '" aria-pressed="' + active +
          '" class="flex flex-col items-start border p-5 text-left transition-colors ' +
          (active ? "border-primary bg-primary/10" : "border-border hover:border-foreground/40") + '">' +
          '<span class="eyebrow text-primary">' + (k.tag ? esc(k.tag) : "&nbsp;") + "</span>" +
          '<span class="display mt-2 text-xl">' + esc(k.title) + "</span>" +
          '<span class="mt-1 text-sm text-muted-foreground">' + esc(k.price + " · " + k.unit) + "</span></button>";
      }).join("");

      var rows = "";
      for (var i = 0; i < state.pairs; i++) {
        rows +=
          '<div><label for="pick-' + i + '" class="eyebrow text-muted-foreground">Par ' + String(i + 1).padStart(2, "0") + "</label>" +
          '<div class="mt-3 flex items-center gap-4">' + thumb(state.picks[i], 20) +
          '<select id="pick-' + i + '" data-pick="' + i + '" class="' + FIELD + ' w-56">' + selectMarkup(i) + "</select></div></div>";
      }

      var sizeButtons = sizes.map(function (s) {
        var active = s === state.size;
        return '<button type="button" data-size="' + esc(s) + '" aria-pressed="' + active +
          '" class="h-12 px-6 text-sm font-semibold transition-colors ' +
          (active ? "bg-primary text-primary-foreground" : "border border-border text-muted-foreground hover:text-foreground") +
          '">' + esc(s) + "</button>";
      }).join("");

      var summaryItems = "";
      for (var j = 0; j < state.pairs; j++) {
        summaryItems +=
          '<li class="flex items-center gap-3 text-sm"><span class="eyebrow text-muted-foreground">' + String(j + 1).padStart(2, "0") + "</span>" +
          thumb(state.picks[j], 10) +
          '<span class="' + (state.picks[j] ? "text-foreground" : "text-muted-foreground") + '">' +
          esc(state.picks[j] || "A escolher") + "</span></li>";
      }

      var consentCfg = CFG.consent || {};
      var consentLink = consentCfg.linkUrl
        ? ' <a class="mc-link" href="' + esc(consentCfg.linkUrl) + '" target="_blank" rel="noopener">' + esc(consentCfg.linkLabel || "Política de Privacidade") + "</a>."
        : "";

      root.innerHTML =
        '<div class="grid gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:items-start">' +
        '<div class="surface-card p-8 md:p-10" id="preorder-form">' +

        '<fieldset><legend class="display text-2xl">1. Escolha o kit</legend>' +
        '<div class="mt-5 grid gap-3 sm:grid-cols-2">' + kitButtons + "</div></fieldset>" +

        '<fieldset class="mt-12"><legend class="display text-2xl">2. Monte seus pares</legend>' +
        '<p class="mt-2 text-sm text-muted-foreground">Para cada par do kit, escolha o modelo e a cor. Pode repetir ou misturar.</p>' +
        '<div class="mt-6 grid gap-5">' + rows + "</div>" + err("picks") + "</fieldset>" +

        (sizes.length
          ? '<fieldset class="mt-12"><legend class="display text-2xl">3. Numeração</legend>' +
            '<div class="mt-5 flex flex-wrap gap-3">' + sizeButtons + "</div>" + err("size") + "</fieldset>"
          : "") +

        '<fieldset class="mt-12"><legend class="display text-2xl">' + (sizes.length ? "4" : "3") + '. Seus dados</legend>' +
        '<div class="mt-5 grid gap-5 sm:grid-cols-2">' +
        '<div><label for="po-name" class="eyebrow text-muted-foreground">Nome completo</label>' +
        '<input id="po-name" maxlength="100" autocomplete="name" placeholder="Seu nome" value="' + esc(buyer.name) + '" class="' + FIELD + ' mt-3" />' + err("name") + "</div>" +
        '<div><label for="po-email" class="eyebrow text-muted-foreground">E-mail</label>' +
        '<input id="po-email" type="email" maxlength="255" autocomplete="email" placeholder="voce@email.com" value="' + esc(buyer.email) + '" class="' + FIELD + ' mt-3" />' + err("email") + "</div>" +
        '<div><label for="po-whats" class="eyebrow text-muted-foreground">WhatsApp (opcional)</label>' +
        '<input id="po-whats" inputmode="tel" maxlength="20" autocomplete="tel" placeholder="(00) 00000-0000" value="' + esc(buyer.whatsapp) + '" class="' + FIELD + ' mt-3" />' + err("whatsapp") + "</div>" +
        '<div><label for="po-city" class="eyebrow text-muted-foreground">Cidade / UF (opcional)</label>' +
        '<input id="po-city" maxlength="80" placeholder="São Paulo / SP" value="' + esc(buyer.city) + '" class="' + FIELD + ' mt-3" />' + err("city") + "</div></div>" +
        '<div class="mt-5"><label for="po-note" class="eyebrow text-muted-foreground">Observação (opcional)</label>' +
        '<textarea id="po-note" rows="3" maxlength="500" placeholder="Algo que a gente precise saber?" class="mt-3 w-full border border-input bg-background px-4 py-3.5 text-base text-foreground placeholder:text-muted-foreground focus:border-primary focus:outline-none">' +
        esc(buyer.note) + "</textarea>" + err("note") + "</div>" +
        '<div class="mt-6"><label class="mc-check" for="po-consent">' +
        '<input type="checkbox" id="po-consent" data-consent' + (state.consent ? " checked" : "") + ">" +
        '<span class="mc-check__text">' + esc(consentCfg.texto || "Aceito receber comunicações da Meioca.") + consentLink + "</span></label>" +
        err("consent") + "</div></fieldset>" +

        '<button type="submit" id="preorder-submit" class="eyebrow mt-10 h-14 w-full bg-primary text-primary-foreground transition-transform hover:-translate-y-0.5"' +
        (state.enviando ? " disabled" : "") + ">" + (state.enviando ? "Enviando…" : "Confirmar pré-venda") + "</button>" +
        '<p class="mt-4 text-xs text-muted-foreground">' + esc(CFG.avisoReserva || "") + "</p>" +
        '<div data-preorder-flash></div>' +
        "</div>" +

        '<aside class="surface-card sticky top-24 p-8">' +
        '<p class="eyebrow flex items-center gap-3 text-primary"><span class="rule-accent"></span>Resumo</p>' +
        '<h2 class="display mt-5 text-3xl">' + esc(kit.title) + "</h2>" +
        '<p class="display mt-3 text-5xl text-primary">' + esc(kit.price) + "</p>" +
        '<p class="mt-2 text-sm text-muted-foreground">' + esc(kit.unit) + "</p>" +
        '<ul class="mt-8 space-y-3 border-t border-border pt-8">' + summaryItems + "</ul>" +
        (sizes.length
          ? '<p class="mt-8 border-t border-border pt-6 text-sm text-muted-foreground">Numeração: <span class="' +
            (state.size ? "text-foreground" : "") + '">' + esc(state.size || "a escolher") + "</span></p>"
          : "") +
        // Texto de configuração do tema, escrito pelo lojista: vai sem escapar
        // para o destaque em laranja funcionar.
        (CFG.previsaoAbertura
          ? '<p class="mt-6 border-t border-border pt-6 text-sm text-muted-foreground">' + CFG.previsaoAbertura + "</p>"
          : "") +
        '<p class="mt-4 text-xs text-muted-foreground">' + esc(CFG.loteInfo || "") + "</p>" +
        "</aside></div>";

      bind();
    }

    function readBuyer() {
      var g = function (id) { var n = document.getElementById(id); return n ? n.value : ""; };
      return { name: g("po-name"), email: g("po-email"), whatsapp: g("po-whats"), city: g("po-city"), note: g("po-note") };
    }

    function adicionarAoCarrinho(kit, buyer) {
      var props = { "Numeração": state.size, "Modelos": modelosEscolhidos().join(" | ") };
      if (buyer.note) props["Observação"] = buyer.note;
      return fetch(CFG.urlCart || "/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: kit.variantId, quantity: 1, properties: props }] })
      }).then(function (r) {
        if (!r.ok) throw new Error("cart/add falhou");
        window.location.href = "/checkout";
      });
    }

    function preparar(buyer) {
      var kit = kitOf();
      var modelos = modelosEscolhidos();
      var perfil = {
        email: buyer.email.trim(),
        first_name: buyer.name.trim().split(" ")[0],
        phone_number: telefoneE164(buyer.whatsapp),
        properties: { "Cidade": buyer.city.trim() || undefined }
      };

      var contato = {
        email: buyer.email.trim(),
        Nome: buyer.name.trim(),
        Origem: "Pré-venda Drop 01",
        Kit: kit.title + " · " + kit.price,
        "Numeracao": state.size,
        Modelos: modelos.join(" | "),
        WhatsApp: buyer.whatsapp.trim(),
        Cidade: buyer.city.trim(),
        Observacao: buyer.note.trim(),
        Aceite: "Sim",
        body:
          "Reserva do Drop 01\n" +
          "Kit: " + kit.title + " (" + kit.price + ")\n" +
          "Numeração: " + state.size + "\n" +
          "Modelos: " + modelos.join(" | ") + "\n" +
          (buyer.whatsapp.trim() ? "WhatsApp: " + buyer.whatsapp.trim() + "\n" : "") +
          (buyer.city.trim() ? "Cidade: " + buyer.city.trim() + "\n" : "") +
          (buyer.note.trim() ? "Observação: " + buyer.note.trim() + "\n" : "")
      };

      // A página navega ao submeter o formulário do Shopify, então guardamos o
      // resumo para remontar a confirmação quando ela voltar.
      try {
        sessionStorage.setItem(GUARDA, JSON.stringify({
          nome: buyer.name,
          email: buyer.email,
          kitTitulo: kit.title,
          kitPreco: kit.price,
          numeracao: state.size,
          modelos: modelos
        }));
      } catch (e) {
        console.warn("[meioca] sessionStorage indisponível:", e);
      }

      // Disparados antes da navegação; o Klaviyo usa keepalive e sobrevive a ela.
      rastrear("reserva", { nome: kit.title, valor: valorNumerico(kit.price) });
      klaviyoInscrever(perfil, "Pré-venda Drop 01");
      klaviyoEvento(KLAVIYO.metricReserva, perfil, {
        Kit: kit.title,
        Pares: state.pairs,
        Preco: kit.price,
        "Numeracao": state.size,
        Modelos: modelos,
        Cidade: buyer.city.trim() || null,
        Observacao: buyer.note.trim() || null
      });

      var formShopify = document.getElementById("meioca-reserva-form");
      if (formShopify) preencherFormulario(formShopify, contato);
    }

    function bind() {
      root.querySelectorAll("[data-kit]").forEach(function (b) {
        b.addEventListener("click", function () {
          state.pairs = parseInt(b.getAttribute("data-kit"), 10);
          for (var i = state.pairs; i < state.picks.length; i++) state.picks[i] = "";
          render(readBuyer());
        });
      });

      root.querySelectorAll("[data-pick]").forEach(function (s) {
        s.addEventListener("change", function () {
          state.picks[parseInt(s.getAttribute("data-pick"), 10)] = s.value;
          render(readBuyer());
        });
      });

      root.querySelectorAll("[data-size]").forEach(function (b) {
        b.addEventListener("click", function () {
          state.size = b.getAttribute("data-size");
          render(readBuyer());
        });
      });

      var check = root.querySelector("[data-consent]");
      if (check) {
        check.addEventListener("change", function () { state.consent = check.checked; });
      }

      // O submit pertence ao formulário do Shopify que embrulha o #preorder-root.
      // Ele é ligado uma única vez, porque render() só troca o conteúdo interno.
      var formShopify = document.getElementById("meioca-reserva-form");
      if (formShopify && !formShopify.dataset.meiocaLigado) {
        formShopify.dataset.meiocaLigado = "1";
        formShopify.setAttribute("novalidate", "");

        formShopify.addEventListener("submit", function (ev) {
          if (state.enviando) return;

          var buyer = readBuyer();
          state.errors = validate(buyer);
          if (Object.keys(state.errors).length) {
            ev.preventDefault();
            render(buyer);
            var alvo = root.querySelector(".text-destructive");
            if (alvo) alvo.scrollIntoView({ behavior: "smooth", block: "center" });
            return;
          }

          var kit = kitOf();
          if (CFG.modo === "carrinho" && kit.variantId) {
            ev.preventDefault();
            adicionarAoCarrinho(kit, buyer).catch(function () {
              flashNode(root.querySelector("[data-preorder-flash]"), "Não foi possível abrir o checkout. Tente de novo em instantes.", true);
            });
            return;
          }

          // Sem preventDefault: preenchemos os campos ocultos e deixamos o
          // Shopify anexar o token de CAPTCHA e submeter de verdade.
          state.enviando = true;
          preparar(buyer);
          var botao = root.querySelector("#preorder-submit");
          if (botao) { botao.disabled = true; botao.textContent = "Enviando…"; }
        });
      }
    }

    render();
  }

  /* ---------------- Lista do drop (2 etapas) ---------------- */

  function mountLead() {
    var raiz = document.querySelector("[data-lead-root]");
    if (!raiz) return;

    var form = raiz.querySelector("form");
    var etapa1 = raiz.querySelector("[data-lead-step-1]");
    var etapa2 = raiz.querySelector("[data-lead-step-2]");
    var cta = raiz.querySelector("[data-lead-cta]");
    if (!form || !etapa1 || !etapa2) return;

    form.setAttribute("novalidate", "");

    // Guarda o e-mail para a etapa 2 sobreviver ao redirect do Shopify.
    var guardado = null;
    try { guardado = sessionStorage.getItem(GUARDA_LEAD); } catch (e) {}
    if (guardado && cta) {
      var base0 = cta.getAttribute("href");
      cta.setAttribute("href", base0 + (base0.indexOf("?") > -1 ? "&" : "?") + "email=" + encodeURIComponent(guardado));
      try { sessionStorage.removeItem(GUARDA_LEAD); } catch (e) {}
    }

    form.addEventListener("submit", function (ev) {
      var campoEmail = form.querySelector('input[type="email"]');
      var consent = form.querySelector("[data-consent]");
      var email = campoEmail ? campoEmail.value.trim() : "";

      if (!validEmail(email)) {
        ev.preventDefault();
        campoEmail.focus();
        flash(etapa1, "Informe um e-mail válido.", true);
        return;
      }
      if (consent && !consent.checked) {
        ev.preventDefault();
        flash(etapa1, "É preciso aceitar para entrar na lista.", true);
        return;
      }

      // Sem preventDefault daqui em diante: o Shopify precisa submeter o
      // formulário de verdade para anexar o token de CAPTCHA.
      try { sessionStorage.setItem(GUARDA_LEAD, email); } catch (e) {}

      rastrear("lista", { nome: "Lista do Drop 01" });
      klaviyoInscrever({ email: email }, "Lista do Drop");
      klaviyoEvento(KLAVIYO.metricLista, { email: email }, { Origem: "Lista do drop" });

      var botao = form.querySelector('button[type="submit"]');
      if (botao) { botao.disabled = true; botao.textContent = "Enviando…"; }
    });
  }

  /* ---------------- Modelo 06 ---------------- */

  function mountFrase() {
    var raiz = document.querySelector("[data-frase-root]");
    if (!raiz) return;

    // Contador de caracteres
    raiz.querySelectorAll("[data-contador]").forEach(function (input) {
      var limite = parseInt(input.getAttribute("data-contador"), 10) || 40;
      var alvo = raiz.querySelector("[data-contador-alvo]");
      if (!alvo) return;
      input.addEventListener("input", function () {
        alvo.textContent = input.value.length + " /" + limite + " caracteres";
      });
    });

    var form = raiz.querySelector("form");
    if (!form) return;
    form.setAttribute("novalidate", "");

    form.addEventListener("submit", function (ev) {
      var frase = form.querySelector('[name="contact[Frase]"]');
      var nome = form.querySelector('[name="contact[Nome]"]');
      var email = form.querySelector('input[type="email"]');
      var consent = form.querySelector("[data-consent]");

      if (!frase || !frase.value.trim()) { ev.preventDefault(); frase.focus(); flash(form, "Escreva a frase.", true); return; }
      if (!nome || !nome.value.trim()) { ev.preventDefault(); nome.focus(); flash(form, "Informe seu nome.", true); return; }
      if (!email || !validEmail(email.value)) { ev.preventDefault(); email.focus(); flash(form, "Informe um e-mail válido.", true); return; }
      if (consent && !consent.checked) { ev.preventDefault(); flash(form, "É preciso aceitar para enviar.", true); return; }

      // Klaviyo é best-effort e não pode atrasar o POST nativo da Shopify.
      var perfil = { email: email.value.trim(), first_name: nome.value.trim().split(" ")[0] };
      klaviyoInscrever(perfil, "Sugestão modelo 06");
      klaviyoEvento(KLAVIYO.metricFrase, perfil, {
        Frase: frase.value.trim(),
        Motivo: (form.querySelector('[name="contact[body]"]') || {}).value || null
      });
      // O formulário segue para a Shopify normalmente (sem preventDefault aqui).
    });
  }

  /* ---------------- Colorways nos cards ---------------- */

  function mountSwatches() {
    document.querySelectorAll("[data-model-card]").forEach(function (card) {
      var img = card.querySelector("[data-model-image]");
      var nome = card.querySelector("[data-model-colorname]");
      var botoes = card.querySelectorAll("[data-swatch]");
      if (!img || !botoes.length) return;

      botoes.forEach(function (b) {
        b.addEventListener("click", function () {
          botoes.forEach(function (o) {
            o.setAttribute("aria-pressed", "false");
            o.className = "h-7 w-7 rounded-full border transition-all border-border hover:border-foreground/40";
          });
          b.setAttribute("aria-pressed", "true");
          b.className = "h-7 w-7 rounded-full border transition-all border-primary ring-2 ring-primary/50 ring-offset-2 ring-offset-card";

          var url = b.getAttribute("data-image");
          var cor = b.getAttribute("data-nome");
          if (url) img.setAttribute("src", url);
          if (cor) {
            img.setAttribute("alt", "Meia Meioca " + (img.getAttribute("data-model-nome") || "") + " — " + cor);
            if (nome) nome.textContent = cor;
          }
        });
      });
    });
  }

  /* ---------------- Avisos e âncoras ---------------- */

  function flash(escopo, mensagem, isErro) {
    var antigo = escopo.querySelector("[data-flash]");
    if (antigo) antigo.remove();
    var box = el("p", "mc-flash " + (isErro ? "mc-flash--erro" : "mc-flash--ok"), esc(mensagem));
    box.setAttribute("data-flash", "");
    escopo.appendChild(box);
  }

  function flashNode(node, mensagem, isErro) {
    if (!node) return;
    node.innerHTML = '<p class="mc-flash ' + (isErro ? "mc-flash--erro" : "mc-flash--ok") + '">' + esc(mensagem) + "</p>";
  }

  function smoothAnchors() {
    document.querySelectorAll('a[href^="#"], a[href^="/#"]').forEach(function (a) {
      a.addEventListener("click", function (ev) {
        var partes = a.getAttribute("href").split("#");
        var hash = partes[1];
        var alvo = hash && document.getElementById(hash);
        if (alvo) {
          ev.preventDefault();
          alvo.scrollIntoView({ behavior: "smooth", block: "start" });
          history.replaceState(null, "", "#" + hash);
        }
      });
    });
  }

  /* ---------------- Boot ---------------- */

  function init() {
    var root = document.getElementById("preorder-root");
    if (root) {
      // Voltando do POST do Shopify: remonta a confirmação e não redesenha o formulário.
      if (document.querySelector("[data-reserva-ok]")) {
        var guardado = null;
        try {
          guardado = JSON.parse(sessionStorage.getItem(GUARDA) || "null");
          sessionStorage.removeItem(GUARDA);
        } catch (e) {}
        if (guardado) { confirmacao(root, guardado); root = null; }
      }
      if (root) mountPreOrder(root);
    }
    mountLead();
    mountFrase();
    mountSwatches();
    smoothAnchors();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  // Reinicializa dentro do editor de temas, que troca seções sem recarregar a página.
  document.addEventListener("shopify:section:load", init);
})();
